<template>
  <article class="user_view">    
    <left-menu/>
    <section class="user_view__header">
      <div @click="$router.push({ path: routePath.split('/').splice(0,routePath.split('/').length-1).join('/') })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <div class="user_view__header--info"> 
        <div>
          <h1>Guardas {{company.name}} </h1>
          <h4 style="margin-top:25px"><b>Puesto de trabajo:   </b><i>{{company.location}}</i></h4>
        </div>
      </div>
      <div class="user_view__header--sec1">
        <!--div class="date_filter">
          <input v-model="dateFrom" placeholder="Desde" onfocus="(this.type='date')" onblur="(this.type='text')" type="text" class="date_filter__selector">
          <input v-model="dateTo" placeholder="Hasta" onfocus="(this.type='date')" onblur="(this.type='text')" type="text" class="date_filter__selector">
          <button :class="{'active': isComplete()}" class="secondary_button" >FILTRAR</button>
        </div-->
        <button  class="secondary_button" :class="{'click':isUpdate, 'active': !isUpdate}"  @click="toUpdate" >ACTUALIZAR</button>
        <div></div>    
      </div>
      <info-table :name="'guardas en '+company.location " :columns="columns" :items.sync="guards" :actions="true"/>

    </section>
  </article>
</template>

<script>
import Table from './../shared/Table';
export default {
  data(){
    return{
      isReported:false,
      isUpdate:false,
      dateFrom:'',
      dateTo:'',
      routePath: this.$route.path,
      company:[],
      columns:[
        {
          name: 'ID',
          sortable: false,
          clickable: true,
        },
        {
          name: 'Nombre',
          sortable: false,
        },
        {
          name: 'Cedula',
          sortable: false,
        },
        {
          name: 'Disp. actual',
          sortable: false,
        },
        {
          name: 'Estado actual en el puesto',
          sortable: false,
        },
        {
          name: 'Acciones',
          lockable:true,
          enabled: true,
        }
      ],   
      guards:[],
      
      
    }
  },
  components:{
      'info-table':Table, 
  },
  methods:{
      changeButton(){
       setTimeout(function(){
          
         this.isUpdate=false;
      },4000,"JavaScript");
          
        
      },
      isComplete(){
        if(this.dateFrom!='' && this.dateTo!=''){
          return true;
        }
      },
      toUpdate() {       
        this.isUpdate=true;    
        this.changeButton();
        var deviceAsignament=this.routePath.split('/').pop();
        const customActions={
          get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
        };
        var card=JSON.parse(localStorage.getItem("user")).id_card; 
        this.$resource('company_devices/new',{},customActions).get({"assigment":deviceAsignament})
        .then(function(data){
          this.guards=data.body.guards;
          this.company=data.body.company;
          //console.log(data.body[0].user);
        });      
      },      
  },
  created(){
    var deviceAsignament=this.routePath.split('/').pop()

    const customActions={
      get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    var card=JSON.parse(localStorage.getItem("user")).id_card; 
    this.$resource('company_devices/new',{},customActions).get({"assigment":deviceAsignament})
    .then(function(data){
      this.guards=data.body.guards;
      this.company=data.body.company;
      //console.log(data.body[0].user);
    });
    //console.log(data.body[0].user);
    
  }
  
}
</script>



// WEBPACK FOOTER //
// src/components/pages/EspecificGuards.vue